import { Close } from "@mui/icons-material";
import {
  Alert,
  IconButton,
  Modal,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { useCallback, useState } from "react";
import { desktopSx } from "src/utils/styles/modalStyles";
import CreateOrderNowTab from "./components/CreateOrderNowTab";
import CreateOrderLaterTab from "./components/CreateOrderLaterTab";

interface Props {
  open: boolean;
  onClose: () => void;
  patientStripeId: string;
  patientId: number | null;
  gender: string | null;
}

const tabs = ["Create now", "Create later"];

const CreateOrderModal = ({
  open,
  onClose,
  patientStripeId,
  patientId,
  gender,
}: Props) => {
  const [isError, setIsError] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [value, setValue] = useState<number>(0);

  const handleClose = useCallback(() => {
    setMessage("");
    setIsError(false);
    setValue(0);
    onClose();
  }, [onClose]);

  const handleChangeTab = useCallback(
    (_: React.SyntheticEvent, newValue: number) => {
      setMessage("");
      setIsError(false);
      setValue(newValue);
    },
    [],
  );

  return (
    <Modal open={open}>
      <Stack sx={desktopSx} gap={2} width={500}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography fontWeight={700} variant="h5">
            Create One Time Order
          </Typography>
          <IconButton onClick={handleClose} sx={{ p: 0 }}>
            <Close fontSize="medium" />
          </IconButton>
        </Stack>
        <Tabs value={value} onChange={handleChangeTab}>
          {tabs.map((tab) => (
            <Tab label={tab} key={tab} />
          ))}
        </Tabs>

        {value === 0 ? (
          <CreateOrderNowTab
            gender={gender}
            patientId={patientId!}
            patientStripeId={patientStripeId}
            setIsError={setIsError}
            setMessage={setMessage}
          />
        ) : (
          <CreateOrderLaterTab
            gender={gender}
            patientId={patientId!}
            setIsError={setIsError}
            setMessage={setMessage}
            patientStripeId={patientStripeId}
          />
        )}
        {message ? (
          <Alert severity={isError ? "error" : "success"}>{message}</Alert>
        ) : null}
      </Stack>
    </Modal>
  );
};

export default CreateOrderModal;
